module.exports = __webpack_public_path__ + "feather.ef0bf66f5cdfc7822401.ttf";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/feather/fonts/feather.ttf?9xfrq8
// module id = ../../../../../src/assets/fonts/feather/fonts/feather.ttf?9xfrq8
// module chunks = styles